<div class="flex flex-col gap-6 w-full">
  <!-- Empty State -->
  <div
    *ngIf="!isGenerated"
    class="flex flex-col items-center justify-center border-2 border-dashed border-[#EAECF0] rounded-xl min-h-[150px] bg-[#F8F8F8] p-4 relative"
  >
    <div class="flex flex-col items-center gap-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/gallery.svg"
        alt="gallery"
        class="w-10 opacity-70"
      />
      <span class="text-[#667085] font-medium text-sm"
        >No QRIS has been generated yet</span
      >
      <span class="text-[#667085] text-xs"
        >Fill in the form on the left to create a dynamic QR code.</span
      >
    </div>
  </div>

  <!-- Generated State -->
  <div
    *ngIf="isGenerated"
    class="flex flex-col gap-6 items-center w-full border border-[#EAECF0] rounded-xl p-6 bg-white"
  >
    <span class="text-[#667085] font-semibold text-lg"
      >QRIS Generated Successfully!</span
    >

    <!-- QR Code -->
    <div class="border border-[#EAECF0] p-2 rounded-lg bg-white">
      <qrcode
        [qrdata]="data?.qris_string || ''"
        imageSrc="https://storage.googleapis.com/komerce/Qrisly/logo-only-qrisly.png"
        [imageHeight]="30"
        [imageWidth]="30"
        [errorCorrectionLevel]="'M'"
        [margin]="1"
        [scale]="1"
        [width]="100"
      ></qrcode>
    </div>

    <!-- Details Card -->
    <div
      class="w-full bg-[#f9fafb] rounded-lg p-2 flex flex-col gap-4"
    >
      <div class="grid grid-cols-2 gap-y-4">
        <!-- Final Amount -->
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#667085]">Final Amount</span>
          <span class="text-sm font-semibold text-darkGray"
            >Rp {{ (data?.final_amount | number : "1.0-2") || 0 }}</span
          >
        </div>
        <!-- Original Amount -->
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#667085]">Original Amount</span>
          <span class="text-sm font-semibold text-darkGray"
            >Rp {{ (data?.original_amount | number : "1.0-2") || 0 }}</span
          >
        </div>

        <div class="col-span-2 border-t border-[#EAECF0] my-1"></div>

        <!-- Payment Status -->
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#667085]">Payment Status</span>
          <span [class]="getClassStatus(data?.payment_status || 'Unpaid')" class="text-xs px-3 py-1 rounded-full w-fit capitalize">
            {{ data?.payment_status || 'Unpaid' }}
          </span>
        </div>
        <!-- Unique Amount -->
        <div class="flex flex-col gap-1">
          <span class="text-xs text-[#667085]">Unique Amount</span>
          <span class="status-success text-xs px-3 py-1 rounded-full w-fit">
            Yes
          </span>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex flex-row gap-4 w-full">
      <button
        (click)="copyQrisCode(data?.qris_string || '')"
        nz-button
        nzType="default"
        class="flex items-center justify-center h-10 flex-1 gap-2"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/copy.svg"
          class="w-5"
          alt="copy"
        />
        Copy QRIS Code
      </button>
      <button
        (click)="downloadQrCode()"
        nz-button
        nzType="primary"
        class="flex-1 h-10"
      >
        Download QR Code
      </button>
    </div>

    <!-- Info Banner -->
    <div
      class="w-full bg-[#FFF2E2] border border-[#FBA63C] rounded-lg p-3 flex flex-row items-center gap-3"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/email/info-circle!.png"
        class="w-5"
        alt="info"
      />
      <span class="text-[12px] text-[#AF6A13]"
        >This QRIS can be used for payments with a predefined amount.</span
      >
    </div>
  </div>
</div>
